// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DynamicImage{width:100%;height:auto;opacity:0;transition:opacity .5s ease;content-visibility:auto;}.DynamicImage--no-fade,.DynamicImage.is-visible{opacity:1}.DynamicImage--rounded{border-radius:10px}.DynamicImage--bg{height:0;background-size:cover;background-position:50%;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
